import KeyMirror from 'keymirror'

// export const API_URL = 'https://api.wordsmine.com'
export const API_URL =
	process.env.REACT_APP_API_URL || 'https://api.wordsmine.com'

export const PRODUCTION_ENV = 'production'
export const DEFAULT_USER_NAME = 'WordsMiner'

export const DEFAULT_PAGE_SIZE = 10
export const SOURCE_WEBAPP = 'webapp' // use in created by, ...

export const ROUTE = {
	DASHBOARD: '/',
	LOGIN: '/login',
	USER_MANAGEMENT: '/user-management',
	CHAT_ENGAGEMENT: '/chat-engagement',
	OVERVIEW: '/overview',
	USER_DETAIL: '/user-detail',
	FEEDBACK_MANAGEMENT: '/feedback-management',
	EMAIL_CONTENT_MANAGEMENT: '/email-content-management',
	BLOG_MANAGEMENT: '/blog-management',
	AGENTS_MANAGEMENT: '/agents-management',
	RELEASE_MANAGEMENT: '/release-management',
	NOTIFICATION_MANAGEMENT: '/notification-management',
	/** @deprecated Use ANNOUNCEMENT_MANAGEMENT — kept for any old bookmarks */
	BANNER_MANAGEMENT: '/product-announcements',
	ANNOUNCEMENT_MANAGEMENT: '/product-announcements',
	LIST: '/list',
	CREATE: '/create',
	PRODUCT_OWNER: '/product-owner',
	CONTENT_MARKETING: '/content-marketing',
	ENGINEER: '/engineer',
	PROJECT_MANAGER: '/project-manager',
	AGENT_CONFIGS: '/agent-configs',
	NOTIFICATION_SEND: '/send',
	EMAIL_SEND: '/send',
	EMAIL_SEND_HISTORY: '/history',
	WORD_MANAGEMENT: '/word-management',
	REPORT: '/report',
	ORDER_MANAGEMENT: '/order-management',
	WORD_TYPES: '/word-types',
	DICTIONARY_MANAGEMENT: '/dict-management',
	COURSE_MANAGEMENT: '/course-management',
	CATEGORY_NEW: '/category-new',
	CATEGORY_INTRO: '/category-intro',
	I18N_MANAGEMENT: '/i18n-management',
	I18N_LANGUAGES: '/languages',
	I18N_TRANSLATIONS: '/translations',
	I18N_COURSES: '/course-translations',
	VOUCHER_MANAGEMENT: '/voucher-management',
}

export const METHOD_AXIOS = {
	GET: 'get',
	POST: 'post',
	PUT: 'put',
	DELETE: 'delete',
}

export const CONTENT_TYPE = {
	MULTIPART_FORM_DATA: 'multipart/form-data',
	FORM_URLENCODED: 'application/x-www-form-urlencoded',
}

export const MESSAGE = {
	ADD_SUCCESS: 'Create successfully',
	UPDATE_SUCCESS: 'Updated successfully',
	DELETE_SUCCESS: 'Deleted successfully',
	SUCCESS: 'Successfully',

	ERROR: 'Something went wrong. Please try later',

	REQUIRED: 'Please enter data',

	CONFIRM_DELETE: 'Are you sure you want to delete this record?',

	INVALID_EMAIL: 'Email is invalid!',
	INVALID_PHONE: 'Phone is invalid!',
	INVALID_CARD_NUMBER: 'Card number is invalid!',
}

export const ORDER_STATUS = KeyMirror({
	PENDING: null,
	SUCCESS: null,
	FAILED: null,
})

export const LANGUAGE = {
	KEY: 'language',
	VI: 'vi',
	EN: 'en',
	DEFAULT: 'vi',
}

export const DICT_LANGUAGE = {
	VI: 'vi',
	EN: 'en',
}

export const EXAMPLE_TYPE = KeyMirror({
	EN: null,
	VI: null,
	VI_TERM: null,
	MORE_EXAMPLE: null,
})

export const KEY_CODE = {
	ENTER: 13,
}
